import { Box, Typography } from "@mui/material";
import Logo from "../assets/images/logo.png";

export default function HeaderPrint() {
  return (
    <Box
      sx={{
        bgcolor: "#cad9fc",
        padding: "10px 20px",
        display: "none",
        displayPrint: "flex",
        alignItems: "center",
        color: "#000",
        // mb: 3,
      }}
    >
      <Box component="img" sx={{ height: 80, width: 80, mr: 5 }} alt="logo" src={Logo} />
      <Box sx={{ flex: 1, textAlign: "center", ml: -10 }}>
        <Typography variant="h1" sx={{ fontSize: 22 }}>
          NEPTUNE DEVELOPMENT LTD
        </Typography>
        <Typography>neptunedcbd@gmail.com, fb/neptunedevelopmentofficial</Typography>
        <Typography>08, Shahid Faruk Road, Jatrabari Dhaka - 1204, www.neptunebd.com</Typography>
      </Box>
    </Box>
  );
}
